(() => {
  const config = document.querySelector('[data-ermen-config]')?.dataset || {};
  const root = config.root || window.Shopify?.routes?.root || '/';
  const endpoint = path => root.replace(/\/?$/, '/') + path;
  const digits = value => String(value || '').replace(/\D/g, '').slice(0, 8);
  const zipFormat = value => digits(value).replace(/^(\d{5})(\d)/, '$1-$2');
  const storage = {
    get(key) { try { return sessionStorage.getItem(`ermen-${key}`) || ''; } catch { return ''; } },
    set(key, value) { try { sessionStorage.setItem(`ermen-${key}`, value); } catch {} }
  };
  const money = (amount, currency) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || config.currency || 'BRL' }).format(Number(amount));
  async function changeCart(input) {
    const form = input.form;
    const page = form?.closest('[data-ermen-cart]');
    const item = input.closest('[data-cart-key]');
    if (!page || !item || !window.fetch || form.dataset.busy === 'true' || !input.checkValidity()) return;
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const status = page.querySelector('[data-ermen-cart-status]');
    const preserved = [...page.querySelectorAll('[name=note],[name=discount],[name=zip],[name=province]')].map(field => ({ name: field.name, value: field.value }));
    const noteOpen = page.querySelector('.em-cart-note')?.open;
    const controls = [...page.querySelectorAll('button,input,select,textarea')];
    const disabled = controls.map(control => control.disabled);
    form.dataset.busy = 'true';
    page.setAttribute('aria-busy', 'true');
    controls.forEach(control => control.disabled = true);
    if (status) status.textContent = page.dataset.updating;
    try {
      const result = await request(endpoint('cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.dataset.cartKey, quantity, sections: [page.dataset.sectionId], sections_url: location.pathname + location.search })
      });
      const html = result.sections?.[page.dataset.sectionId];
      const replacement = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ermen-cart]') : null;
      if (!replacement) {
        storage.set('note', form.querySelector('[name=note]')?.value || '');
        location.reload();
        return;
      }
      initialize(replacement);
      preserved.forEach(field => {
        const target = replacement.querySelector(`[name="${CSS.escape(field.name)}"]`);
        if (target) target.value = field.value;
      });
      const note = replacement.querySelector('.em-cart-note');
      if (note) note.open = Boolean(noteOpen);
      page.replaceWith(replacement);
      counts(result.item_count);
      const message = replacement.querySelector('[data-ermen-cart-status]');
      if (message) message.textContent = replacement.dataset.updated;
      const nextInput = replacement.querySelector(`[data-cart-key="${CSS.escape(item.dataset.cartKey)}"] [name="updates[]"]`);
      (nextInput || replacement.querySelector('h1'))?.focus({ preventScroll: true });
    } catch (error) {
      if (status) status.textContent = typeof error.data?.description === 'string' ? error.data.description : page.dataset.updateError;
    } finally {
      form.dataset.busy = 'false';
      page.removeAttribute('aria-busy');
      controls.forEach((control, index) => control.disabled = disabled[index]);
    }
  }
  async function request(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const data = await response.json();
    if (!response.ok) throw Object.assign(new Error(data?.description || data?.message || 'request_failed'), { data, status: response.status });
    return data;
  }
  function counts(count) {
    document.querySelectorAll('.em-cart-count').forEach(node => node.textContent = String(count));
    document.querySelectorAll('.em-cart-button').forEach(node => node.setAttribute('aria-label', `${config.cartLabel || ''}, ${count}`));
  }
  function notify(message) {
    const box = document.querySelector('[data-ermen-notification]');
    if (!box) return;
    box.querySelector('[data-ermen-notification-text]').textContent = message;
    box.hidden = false;
  }
  document.querySelector('[data-ermen-notification-close]')?.addEventListener('click', () => document.querySelector('[data-ermen-notification]').hidden = true);
  function showMedia(scope, id) {
    if (!id || !scope.querySelector(`[data-media-id="${CSS.escape(id)}"]`)) return;
    scope.querySelectorAll('[data-media-id]').forEach(node => {
      node.hidden = node.dataset.mediaId !== String(id);
      if (node.hidden) node.querySelectorAll('video').forEach(video => video.pause());
    });
    scope.querySelectorAll('[data-ermen-media]').forEach(node => node.setAttribute('aria-pressed', String(node.dataset.ermenMedia === String(id))));
  }
  function variantChange(select) {
    const scope = select.closest('[data-ermen-product]');
    const option = select.selectedOptions[0];
    if (!scope || !option) return;
    const available = option.dataset.available === 'true';
    scope.querySelector('[data-ermen-price]').textContent = option.dataset.price;
    const compare = scope.querySelector('[data-ermen-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = option.dataset.onSale !== 'true';
    const stock = scope.querySelector('[data-ermen-stock]');
    stock.textContent = available ? scope.dataset.available : scope.dataset.soldOut;
    stock.classList.toggle('em-stock-unavailable', !available);
    scope.querySelectorAll('[data-ermen-add],[data-ermen-shipping-add]').forEach(button => button.disabled = !available || select.form.dataset.busy === 'true');
    scope.querySelector('[data-ermen-add] span').textContent = available ? scope.dataset.addLabel : scope.dataset.soldOut;
    const input = scope.querySelector('[name=quantity]');
    input.min = option.dataset.min || '1';
    input.step = option.dataset.increment || '1';
    if (option.dataset.max) input.max = option.dataset.max;
    else input.removeAttribute('max');
    input.value = input.min;
    showMedia(scope, option.dataset.media);
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  }
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-ermen-remove]');
    if (remove && window.fetch) {
      event.preventDefault();
      const form = remove.closest('form');
      if (form?.dataset.busy === 'true') return;
      const input = remove.closest('[data-cart-key]').querySelector('[name="updates[]"]');
      input.value = '0';
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('[data-ermen-quantity]').querySelector('input');
      const previous = input.value;
      if (Number(stepper.dataset.quantityStep) > 0) input.stepUp();
      else input.stepDown();
      if (previous !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const thumb = event.target.closest('[data-ermen-media]');
    if (thumb) showMedia(thumb.closest('[data-ermen-gallery]'), thumb.dataset.ermenMedia);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ermen-variant]')) variantChange(event.target);
    if (event.target.matches('[data-ermen-sort-submit]')) event.target.form.requestSubmit();
    if (event.target.matches('[data-ermen-state]')) {
      const estimator = event.target.closest('[data-ermen-shipping]');
      estimator?._abort?.abort();
      if (estimator) {
        estimator.querySelector('[data-ermen-shipping-rates]').hidden = true;
        estimator.querySelector('[data-ermen-shipping-status]').textContent = '';
      }
    }
    if (event.target.matches('.em-cart-form [name="updates[]"]')) {
      event.target.form.dataset.dirty = 'true';
      const estimator = document.querySelector('[data-ermen-shipping]');
      if (estimator) {
        estimator._abort?.abort();
        estimator.dataset.dirty = 'true';
        estimator.querySelector('[data-ermen-shipping-rates]').hidden = true;
        estimator.querySelector('[data-ermen-shipping-status]').textContent = estimator.dataset.cartChanged;
      }
      changeCart(event.target);
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-ermen-zip],[data-ermen-product-zip]')) {
      event.target.value = zipFormat(event.target.value);
      const estimator = event.target.closest('[data-ermen-shipping]');
      if (estimator) {
        estimator._abort?.abort();
        estimator.querySelector('[data-ermen-shipping-rates]').hidden = true;
        estimator.querySelector('[data-ermen-shipping-status]').textContent = '';
      }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('.em-cart-form') && form.dataset.busy === 'true') {
      event.preventDefault();
      return;
    }
    if (form.matches('[data-ermen-coupon]')) {
      event.preventDefault();
      if (form.dataset.busy === 'true') return;
      const status = form.querySelector('[role=status]');
      if (document.querySelector('.em-cart-form')?.dataset.dirty === 'true') {
        status.textContent = form.dataset.dirty;
        return;
      }
      const code = form.querySelector('[name=discount]').value.trim();
      if (!code) return;
      form.dataset.busy = 'true';
      form.setAttribute('aria-busy', 'true');
      const button = form.querySelector('button');
      button.disabled = true;
      status.textContent = '';
      try {
        const current = await request(endpoint('cart.js'));
        const codes = new Set((current.discount_codes || []).filter(discount => discount.applicable).map(discount => discount.code));
        codes.add(code);
        const updated = await request(endpoint('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: [...codes].join(',') }) });
        const valid = updated.discount_codes?.some(discount => discount.code.toLowerCase() === code.toLowerCase() && discount.applicable);
        if (!valid) {
          status.textContent = form.dataset.invalid;
          return;
        }
        location.reload();
      } catch {
        status.textContent = form.dataset.error;
      } finally {
        form.dataset.busy = 'false';
        form.removeAttribute('aria-busy');
        button.disabled = false;
      }
      return;
    }
    if (!form.matches('.em-product-form')) return;
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const scope = form.closest('[data-ermen-product]');
    const shipping = event.submitter?.hasAttribute('data-ermen-shipping-add');
    const zip = scope?.querySelector('[data-ermen-product-zip]');
    if (shipping && zip && digits(zip.value).length !== 8) {
      zip.setCustomValidity(scope.dataset.invalidZip);
      zip.reportValidity();
      zip.addEventListener('input', () => zip.setCustomValidity(''), { once: true });
      return;
    }
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    const buttons = [...form.querySelectorAll('button[type=submit]'), ...document.querySelectorAll(`button[form="${CSS.escape(form.id)}"]`)];
    const previous = buttons.map(button => button.disabled);
    buttons.forEach(button => button.disabled = true);
    const status = scope?.querySelector('[data-ermen-form-status]');
    if (status) status.textContent = '';
    try {
      const data = new FormData(form);
      data.delete('return_to');
      await request(endpoint('cart/add.js'), { method: 'POST', body: data });
      if (shipping) {
        storage.set('zip', digits(zip.value));
        location.assign((scope?.dataset.cartUrl || endpoint('cart')) + '#frete');
        return;
      }
      try { const cart = await request(endpoint('cart.js')); counts(cart.item_count); } catch {}
      if (status) status.textContent = config.added;
      notify(config.added);
    } catch (error) {
      const text = typeof error.data?.description === 'string' ? error.data.description : config.addError;
      if (status) status.textContent = text;
      else notify(text);
    } finally {
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => {
        const option = scope?.querySelector('[data-ermen-variant]')?.selectedOptions[0];
        button.disabled = option ? option.dataset.available !== 'true' : previous[index];
      });
    }
  });
  async function provinceFromZip(zip, signal) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${zip}/json/`, { signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
      if (!response.ok) return null;
      const data = await response.json();
      if (data.erro) return { invalid: true };
      return data;
    } catch (error) {
      if (signal.aborted) throw error;
      return null;
    }
  }
  function renderRates(scope, rates) {
    const list = scope.querySelector('[data-ermen-shipping-rates]');
    list.replaceChildren();
    for (const rate of [...rates].sort((a, b) => Number(a.price) - Number(b.price))) {
      if (!Number.isFinite(Number(rate.price)) || Number(rate.price) < 0) continue;
      const row = document.createElement('li');
      row.className = 'em-shipping-rate';
      const name = String(rate.presentment_name || rate.name || rate.code || '');
      if (!name.trim()) continue;
      if (/sedex/i.test(name)) row.classList.add('em-sedex');
      const description = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = name;
      description.append(title);
      if (rate.description) {
        const note = document.createElement('small');
        note.textContent = String(rate.description);
        description.append(note);
      } else if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
        const valid = rate.delivery_days.filter(day => Number.isFinite(Number(day)) && Number(day) >= 0).map(Number);
        if (valid.length) {
          const note = document.createElement('small');
          const min = Math.min(...valid), max = Math.max(...valid);
          note.textContent = `${min === max ? min : `${min}–${max}`} ${scope.dataset.days}`;
          description.append(note);
        }
      }
      const price = document.createElement('span');
      price.className = 'em-shipping-price';
      try { price.textContent = Number(rate.price) === 0 ? scope.dataset.free : money(rate.price, rate.currency); } catch { continue; }
      row.append(description, price);
      list.append(row);
    }
    list.hidden = list.children.length === 0;
    return list.children.length;
  }
  async function estimate(form) {
    const scope = form.closest('[data-ermen-shipping]');
    if (!scope) return;
    scope._abort?.abort();
    const controller = new AbortController();
    scope._abort = controller;
    const signal = controller.signal;
    const timeout = setTimeout(() => controller.abort('timeout'), 35000);
    const zipInput = form.querySelector('[name=zip]');
    const stateInput = form.querySelector('[name=province]');
    const zip = digits(zipInput.value);
    const status = scope.querySelector('[data-ermen-shipping-status]');
    const list = scope.querySelector('[data-ermen-shipping-rates]');
    const button = form.querySelector('button');
    list.hidden = true;
    status.textContent = scope.dataset.loading;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    try {
      if (scope.dataset.dirty === 'true') throw new Error('cart_changed');
      if (zip.length !== 8) throw new Error('invalid_zip');
      const address = await Promise.race([provinceFromZip(zip, signal), new Promise(resolve => setTimeout(() => resolve(null), 5000))]);
      if (signal.aborted) return;
      if (address?.invalid) throw new Error('invalid_zip');
      if (address?.uf) {
        const match = [...stateInput.options].find(option => option.textContent.trim() === address.uf);
        if (match) stateInput.value = match.value;
      }
      if (!stateInput.value) throw new Error('missing_state');
      const cart = await request(endpoint('cart.js'), { signal });
      if (!cart.item_count || !cart.requires_shipping) throw new Error('no_cart');
      const query = new URLSearchParams({ 'shipping_address[zip]': zipFormat(zip), 'shipping_address[country]': 'Brazil', 'shipping_address[province]': stateInput.value });
      await request(endpoint(`cart/prepare_shipping_rates.json?${query}`), { method: 'POST', signal });
      let result = null;
      for (let attempt = 0; attempt < 16; attempt++) {
        if (signal.aborted) return;
        result = await request(endpoint(`cart/async_shipping_rates.json?${query}`), { signal });
        if (result !== null) break;
        await new Promise(resolve => setTimeout(resolve, 1100));
      }
      if (signal.aborted) return;
      if (!result) throw new Error('rates_timeout');
      storage.set('zip', zip);
      storage.set('province', stateInput.value);
      const count = renderRates(scope, Array.isArray(result.shipping_rates) ? result.shipping_rates : []);
      status.textContent = count ? '' : scope.dataset.empty;
    } catch (error) {
      if (signal.aborted && signal.reason !== 'timeout') return;
      status.textContent = error.message === 'cart_changed' ? scope.dataset.cartChanged : error.message === 'invalid_zip' ? scope.dataset.invalid : error.message === 'missing_state' ? scope.dataset.selectState : error.message === 'no_cart' ? scope.dataset.noCart : scope.dataset.error;
    } finally {
      clearTimeout(timeout);
      if (scope._abort === controller) {
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    }
  }
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-ermen-shipping-form]')) return;
    event.preventDefault();
    estimate(event.target);
  });
  function initialize(scope = document) {
    const savedNote = storage.get('note');
    const note = scope.querySelector('[name=note]');
    if (savedNote && note && !note.value) {
      note.value = savedNote;
      storage.set('note', '');
    }
    scope.querySelectorAll('[data-ermen-product-zip],[data-ermen-zip]').forEach(input => {
      if (!input.value) input.value = zipFormat(storage.get('zip'));
    });
    scope.querySelectorAll('[data-ermen-state]').forEach(select => {
      select.required = false;
      select.value = storage.get('province');
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
